<script>
    import Image from './Image.svelte';
</script>

<div class="section mt-3 mb-3">
    <div class="row">
        <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
            <div class="card">
                <Image src="/img/wide0.jpg" class="card-img-top" alt="image" style="height: 300px;object-fit: cover;" />
                
                <div class="card-body placeholder-glow">
                    <h2 class="title text-md-center"><span class="placeholder col-6"></span></h2>
                    <div class="card-text text-md-center">
                        <p class="placeholder col-10"></p>
                        <p class="placeholder col-4"></p>
                    </div>
                </div>
                
                <div class="card-footer text-center">
                    <button type="button" class="btn btn-primary btn-block">
                        <span class="placeholder col-4"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
